<template>
  <naj-modal
    ref="modal"
    :title="local.caseRelatedRequest.cassationRequest.casePartiesModalTitle"
    :width="700"
    :footer="true"
    :persistent="true"
    show-footer-close-button
    @onClose="handleClose"
  >
    <v-simple-table class="objected-parties-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-right">
              {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.partyName }}
            </th>
            <th class="text-right">
              {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.partyRole }}
            </th>
            <th class="text-center">
              {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.action }}
            </th>
            <th class="text-center">
              {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.status }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="party in allParties"
            :key="party.casePartyId"
            class="party-row"
          >
            <td class="text-right">
              {{ party.name }}
            </td>
            <td class="text-right">
              {{ party.casePartyRoleName }}
            </td>
            <td class="text-center">
              <v-btn
                v-if="isPartySelected(party.casePartyId)"
                icon
                small
                class="delete-btn"
                @click="removeParty(party.casePartyId)"
              >
                <v-icon
                  color="white"
                  size="18"
                >
                  mdi-delete
                </v-icon>
              </v-btn>
              <naj-button
                v-else
                icon="mdi-plus"
                size="small"
                @click="addParty(party.casePartyId)"
              >
                {{ local.common.add }}
              </naj-button>
            </td>
            <td class="text-center">
              <span
                v-if="isPartySelected(party.casePartyId)"
                class="status-badge status-added"
              >
                <span class="status-dot added" />
                {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.added }}
              </span>
              <span
                v-else
                class="status-badge status-not-added"
              >
                <span class="status-dot not-added" />
                {{ local.caseRelatedRequest.cassationRequest.objectedPartiesTable.notAdded }}
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button @click="handleSave(closeNajModal)">
        {{ local.common.save }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
export default {
  name: 'ObjectedPartiesModal',
  props: {
    modalVisibility: {
      type: Boolean,
      default: false,
    },
    allParties: {
      type: Array,
      default: () => [],
    },
    selectedPartyIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { localSelectedIds: [] };
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.localSelectedIds = [...(this.selectedPartyIds || [])];
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
      }
    },
  },
  methods: {
    isPartySelected(casePartyId) {
      return this.localSelectedIds.includes(casePartyId);
    },
    addParty(casePartyId) {
      if (!this.localSelectedIds.includes(casePartyId)) {
        this.localSelectedIds.push(casePartyId);
      }
    },
    removeParty(casePartyId) {
      const index = this.localSelectedIds.indexOf(casePartyId);
      if (index > -1) {
        this.localSelectedIds.splice(index, 1);
      }
    },
    handleSave(closeNajModal) {
      this.$emit('save', [...this.localSelectedIds]);
      closeNajModal();
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.objected-parties-table {
  thead th {
    background-color: #f5f5f5 !important;
    font-weight: bold;
    font-size: 14px !important;
    color: #333 !important;
    border-bottom: 2px solid #e0e0e0 !important;
  }

  .party-row {
    td {
      padding: 12px 16px !important;
      border-bottom: 1px solid #eee !important;
    }
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 16px;

  &.status-added {
    color: #2e7d32;
    background-color: #e8f5e9;
  }

  &.status-not-added {
    color: #757575;
    background-color: #f5f5f5;
  }
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;

  &.added {
    background-color: #4caf50;
  }

  &.not-added {
    background-color: #bdbdbd;
  }
}

.delete-btn {
  background-color: #d32f2f !important;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
